import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

export const rootRouterConfig: Routes = [
  {
    path: '',
    redirectTo: 'session',
    pathMatch: 'full'
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then(m => m.UserModule)
  },
  {
    path: 'session',
    loadChildren: () => import('./session/session.module').then(m => m.SessionModule)
  }
];
// export const ModuleRouting: ModuleWithProviders<any> = RouterModule.forRoot(rootRouterConfig, { relativeLinkResolution: 'legacy' });
export const ModuleRouting: ModuleWithProviders<any> = RouterModule.forRoot(rootRouterConfig)